import React, {useMemo} from "react";
import "./style.css";
import {NotRecommended} from "./NotRecommended";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";
import {DIETARY_PREFERENCE} from "../../../../const/WeightLossQuestionnaire";
import {getNotRecommendedDietaryPreferences} from "../../../../utils/common";

export const DietaryPreference = (props) => {
  // 获取不推荐的饮食偏好列表
  const notRecommendedItems = useMemo(() => {
    return getNotRecommendedDietaryPreferences(props.data?.healthConcerns);
  }, [props.data?.healthConcerns]);

  // 从可选列表中过滤掉不推荐的选项
  const filteredDietaryPreference = useMemo(() => {
    return DIETARY_PREFERENCE.filter(item => !notRecommendedItems.includes(item.content));
  }, [notRecommendedItems]);

  const list = {
    title: "Do you have any specific dietary preference?",
    list: filteredDietaryPreference
  };

  return (
    <div className="gallery-page">
      <QuestionnaireSelect {...props} list={list} />
      <NotRecommended data={props.data}/>
    </div>
  );
};
